// tslint:disable-next-line:max-line-length
import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

const styles = (theme: Theme) => createStyles({
    wrapper: {
        
    },
    destructive: {
        color: theme.palette.error.main,
    },
    // the look of a "discard" confirmation (isAgreeDestructive): a rounded card, a warning icon beside the title and roomier buttons
    destructivePaper: {
        borderRadius: 12,
    },
    destructiveTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    destructiveIcon: {
        flex: '0 0 auto',
        width: 40,
        height: 40,
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(224, 90, 0, 0.12)',
        color: '#E05A00',
        '& svg': {
            fontSize: 22,
        },
    },
    destructiveActions: {
        padding: theme.spacing(1, 3, 2),
        gap: theme.spacing(1),
    },
});

interface DialogBoxProps extends WithStyles<typeof styles> {
    className?: string;
    isAgree?: (agree: boolean) => void;
    ariaLabelledBy?: string;
    ariaDescribedBy?: string;
    title?: string;
    disAgreeLabel?: string;
    agreeLabel?: string;
    content?: string;
    show: boolean;
    alert?: React.ReactNode;
    disablePortal?: boolean;
    hideDisagree?: boolean;
    reverseActionsOrder?: boolean;
    // For a confirmation whose "agree" throws something away (discarding changes): the agree button is shown in the error colour, and the safe
    // (disagree) button is the one focused, so pressing Enter by habit does not discard anything.
    isAgreeDestructive?: boolean;
}

// tslint:disable-next-line:no-empty-interface
interface DialogBoxStates {
    show: boolean;
}

class DialogBox extends React.Component<DialogBoxProps, DialogBoxStates> {
    // tslint:disable-next-line:no-any
    constructor(props: DialogBoxProps, context?: any) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.state = {
            show: this.props.show
        };
    }

    public UNSAFE_componentWillReceiveProps(nextProps: DialogBoxProps) {
        this.setState({show: nextProps.show});
    }

    public render() {
        // const { classes } = this.props;
        if (!this.props.show) {
            return null;
        }

        const disagreeButton = (
            !this.props.hideDisagree && this.handleClose &&
            <Button
                onClick={this.handleClose}
                color="primary"
                variant={this.props.isAgreeDestructive ? 'contained' : undefined}
                autoFocus={!!this.props.isAgreeDestructive}
            >
                {this.props.disAgreeLabel ? this.props.disAgreeLabel : 'No'}
            </Button>
        );

        const agreeButton = (
            <Button
                onClick={this.handleOk}
                color="primary"
                className={this.props.isAgreeDestructive ? this.props.classes.destructive : undefined}
                autoFocus={!this.props.isAgreeDestructive}
            >
                {this.props.agreeLabel ? this.props.agreeLabel : 'Yes'}
            </Button>
        );

        return (
           <React.Fragment>
                {/* <div className={classes.wrapper + ' ' + this.props.className}> */}
                    <Dialog
                        open={this.state.show}
                        onClose={this.handleClose}
                        aria-labelledby={this.props.ariaLabelledBy}
                        aria-describedby={this.props.ariaDescribedBy}
                        maxWidth="sm"
                        fullWidth={true}
                        disablePortal={this.props.disablePortal}
                        classes={this.props.isAgreeDestructive ? { paper: this.props.classes.destructivePaper } : undefined}
                    >
                        <DialogTitle id={this.props.ariaLabelledBy}>
                            {this.props.isAgreeDestructive ? (
                                <div className={this.props.classes.destructiveTitleRow}>
                                    <span className={this.props.classes.destructiveIcon}><ReportProblemOutlinedIcon /></span>
                                    <span>{this.props.title}</span>
                                </div>
                            ) : this.props.title}
                        </DialogTitle>
                        <DialogContent>
                            {this.props.children}
                            <DialogContentText id={this.props.ariaDescribedBy}>
                                {this.props.content}
                            </DialogContentText>
                            {this.props.alert}
                        </DialogContent>
                        <DialogActions className={this.props.isAgreeDestructive ? this.props.classes.destructiveActions : undefined}>
                            {this.props.reverseActionsOrder ? (
                                <>
                                    {agreeButton}
                                    {disagreeButton}
                                </>
                            ) : (
                                <>
                                    {disagreeButton}
                                    {agreeButton}
                                </>
                            )}
                        </DialogActions>
                    </Dialog>
                {/* </div> */}
           </React.Fragment>
        );
    }

    private handleClose(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ show: false });
        if (this.props.isAgree) {
            return this.props.isAgree(false);
        }
    }

    private handleOk(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ show: false });
        if (this.props.isAgree) {
            return this.props.isAgree(true);
        }
    }
}

// tslint:disable-next-line:no-any
export default withStyles(styles as any, { withTheme: true })(DialogBox as any) as any;